export const SAVE_CONTACT_DETAIL = 'ContactUs/SAVE_CONTACT_DETAIL';
export const SAVE_CONTACT_DETAIL_FAILURE = 'ContactUs/SAVE_CONTACT_DETAIL_FAILURE';
export const SET_LOADING = 'ContactUs/SET_LOADING';
export const RESET_CONTACT_OPTION = 'ContactUs/RESET_CONTACT_OPTION';